import * as React from 'react';
import { useMooskinContext } from '@moosend/mooskin';
import { SupportedLanguages, ISupportedLanguage } from '@moosend/mooskin';
import { ITimezone } from '../reactCommons/model';
import Timezones from './static/Timezones';
import { translateText } from './translationHelper';

export const useDebounce = (value: any, delay: number) => {
	const [debouncedValue, setDebouncedValue] = React.useState(value);

	React.useEffect(() => {
		const handler = setTimeout(() => {
			setDebouncedValue(value);
		}, delay);

		return () => {
			clearTimeout(handler);
		};
	}, [value]);

	return debouncedValue;
};

// TODO: we can expose more of Transifex API methods in this hook if needed
export const useTransifex = ({ onTranslatePage }: { onTranslatePage?: (languageCode: ISupportedLanguage) => void } = {}) => {
	const { locale, setLocale } = useMooskinContext();
	const [activeLanguage, setActiveLanguage] = React.useState<ISupportedLanguage>(SupportedLanguages.English);
	const [translatedTimezones, setTranslatedTimezones] = React.useState<ITimezone[]>(Timezones);

	React.useEffect(() => {
		window.Transifex?.live.onTranslatePage((languageCode: ISupportedLanguage): void => {
			// Update local state
			setLocale?.(languageCode);
			setActiveLanguage(languageCode);
			setTranslatedTimezones(Timezones.map((timezone: ITimezone) => ({
				...timezone,
				text: translateText(timezone.text)
			})));
			// Execute the listener
			onTranslatePage?.(languageCode);
		});
	}, [])

	return {
		activeLanguage,
		translatedTimezones,
		activeLocale: locale, // the active Locale object as exposed from Mooskin in case we need it
	};
}
